import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import AssetOwnerDashboard from '../../../Component/DashBoard/User/AssetOwnerDashboard';


const AODashboard = () => {
  return (
    <Fragment>
      <Breadcrumbs parent="Dashboards" title="Dashboard" />
      <AssetOwnerDashboard />
    </Fragment>
  );
};
export default AODashboard;